module.exports = __webpack_public_path__ + "static/media/avdeling.d073ef55.m4a";